import { createAction } from 'typesafe-actions'

export const resetConfigurationProcess = createAction('CMD / Reset / configuration process')<{ navigate?: boolean } | undefined>()
